import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import './TextElementProductsSlider.css'

class TextElementProductsSlider {
  init () {
    let textElementsSlides = document.querySelectorAll('.text-elements-slide');
    if (textElementsSlides.length > 0) {
      textElementsSlides.forEach((sliderElement, index) => {

        const swiper = new Swiper(sliderElement.querySelector('.swiper'), {
          modules: [Navigation, Pagination],
          slidesPerView: 2,
          spaceBetween: 30,
          breakpoints: {
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 }
          },
          // Пагинация
          pagination: {
            el: sliderElement.querySelector('.swiper-pagination'),
            clickable: true,
          },

          // Навигация
          navigation: {
            prevEl: sliderElement.querySelector('.swiper-button-prev'),
            nextEl: sliderElement.querySelector('.swiper-button-next'),
          }
        });
      })
    }
  }
}

export default TextElementProductsSlider